<mat-chip class="chip" [attr.aria-label]="labelKey() ? (labelKey() | transloco: { name: name() }) : name()">
	<div class="chip-content">
		<mat-icon class="material-symbols-outlined" aria-hidden="true">{{ icon() }}</mat-icon>
		@if (labelKey()) {
			<span class="text">{{ labelKey() | transloco: { name: name() } }}</span>
		} @else {
			<span class="text">{{ name() }}</span>
		}
	</div>
</mat-chip>
